import React from 'react'
import styled from 'styled-components'

type Props = {
  message: string
}
export const ValidationErrorMessage: React.FC<Props> = props => {
  return <Balloon>{props.message}</Balloon>
}

const Balloon = styled.div`
  position: absolute;
  left: 0;
  top: 48px;
  display: inline-block;
  padding: 7px 10px;
  min-width: 120px;
  max-width: 100%;
  color: #f35444;
  font-size: 12px;
  font-weight: 300;
  line-height: 16px;
  background: #ffeeec;
  border: 1px solid #f35444;
  border-radius: 4px;
  margin-bottom: 10px;
  margin-top: 3px;
  z-index: 1;
  &::before {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 10px;
    border: 8px solid transparent;
    border-bottom: 8px solid #ffeeec;
    z-index: 2;
  }

  &::after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 9px;
    border: 9px solid transparent;
    border-bottom: 9px solid #f35444;
    z-index: 1;
  }
`
